var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.session && _vm.url)?_c('iframe',{staticClass:"bng-covid",attrs:{"src":_vm.url,"allow":"autoplay; fullscreen","allowfullscreen":"true","webkitallowfullscreen":"true","mozallowfullscreen":"true"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/covid/covid.vue?vue&type=template&id=33456b9c
// module id = 9K5l
// module chunks = 0